

  <ng-container
    *ngFor="let pdfPageInfo  of (pageInfosObs | async); trackBy: trackByIdx"
  >
      <ss-pdf-thumbnail [pdfPageInfo]="pdfPageInfo"> </ss-pdf-thumbnail>
  </ng-container>
